import React from 'react';
import Icon from '../../../components/AppIcon';


const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-brand-primary via-blue-800 to-brand-secondary overflow-hidden">
      <div className="absolute inset-0 bg-black/20"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
              <Icon name="Shield" size={16} className="text-brand-accent" />
              <span className="text-sm font-medium">AI Independence Champions</span>
            </div>
            
            <h1 className="text-4xl lg:text-6xl font-bold mb-6 leading-tight">
              Reclaim Your
              <span className="block text-brand-accent">AI Destiny</span>
            </h1>
            
            <p className="text-xl lg:text-2xl text-blue-100 mb-8 leading-relaxed">
              We help enterprises break free from vendor lock-in and build sustainable AI capabilities through open-source innovation and internal expertise development.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex items-center space-x-3 text-blue-100">
                <Icon name="CheckCircle" size={20} className="text-brand-accent flex-shrink-0" />
                <span>Vendor-Independent Solutions</span>
              </div>
              <div className="flex items-center space-x-3 text-blue-100">
                <Icon name="CheckCircle" size={20} className="text-brand-accent flex-shrink-0" />
                <span>Open-Source Expertise</span>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative z-10 bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-white mb-2">500+</div>
                  <div className="text-blue-200 text-sm">AI Transformations</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-white mb-2">85%</div>
                  <div className="text-blue-200 text-sm">Cost Reduction</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-white mb-2">12M+</div>
                  <div className="text-blue-200 text-sm">Lines of Open Source</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-white mb-2">24/7</div>
                  <div className="text-blue-200 text-sm">AI Independence</div>
                </div>
              </div>
            </div>
            
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-brand-accent/20 rounded-full blur-xl"></div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-blue-400/20 rounded-full blur-xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;